export const basePath = "https://blog.nickbennett.co.uk";
